import { fetch } from "../lib/network";
import decamelizeKeysDeep from "decamelize-keys-deep";
import AppSettings from "../config";

export const getNotifyCRMTopics = (networkHeaders: any) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms/classifications`, {
    method: "GET",
    headers: networkHeaders,
  }).then(async (res) => {
    return await res.json();
  });

export const getEmailSubscriptionGroups = (networkHeaders: any) => (key: string, email: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/email_subscriptions?email=${encodeURIComponent(email)}`, {
    method: "GET",
    headers: networkHeaders,
  }).then(async (res) => ({
    json: await res.json(),
    response: res,
  }));
export const subscribeAllEmails = (networkHeaders: any) => (email: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/email_subscriptions?email=${encodeURIComponent(email)}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ email }),
  });

export const unsubscribeAllEmails = (networkHeaders: any, email: string) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/email_subscriptions?email=${encodeURIComponent(email)}`, {
    method: "DELETE",
    headers: networkHeaders,
  });

export const subscribeEmailGroup =
  (networkHeaders: any, email: string) =>
  ({ id }: any) =>
    fetch(`${AppSettings.NOTIFICATIONS_API_URL}/email_subscriptions/${id}?email=${encodeURIComponent(email)}`, {
      method: "POST",
      headers: networkHeaders,
      body: JSON.stringify({ email }),
    });

export const unsubscribeEmailGroup =
  (networkHeaders: any, email: string) =>
  ({ id }: any) =>
    fetch(`${AppSettings.NOTIFICATIONS_API_URL}/email_subscriptions/${id}?email=${encodeURIComponent(email)}`, {
      method: "DELETE",
      headers: networkHeaders,
    });

export const getPublicBulletin = (networkHeaders: any) => (key: any, id: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/public/${id}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => (res.ok ? res.json() : null));

export const getBulletins = (networkHeaders: any) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getBulletin = (networkHeaders: any) => (id: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms/${id}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getAppDownloadLinks = (networkHeaders: any) => (site: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/public/downloads/${site}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const updateBulletin = (networkHeaders: any, id: number) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const postNotificationsCms = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const putNotificationsCms = (networkHeaders: any, id: string) => (body: any) => {
  return fetch(`${AppSettings.NOTIFICATIONS_API_URL}/cms/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });
};

export const postNotificationsDeliver = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/deliver`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const putNotificationsDeliver = (networkHeaders: any) => (massNotificationId: string, body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/deliver/reschedule/${massNotificationId}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const postNotificationsDeliverTest = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/deliver/test`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const getCommunicationGroups = (networkHeaders: any) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/groups`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCommunicationGroup = (networkHeaders: any) => (key: any, id: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/groups/${id}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const postCommunicationGroup = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/groups`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const putCommunicationGroup = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/groups/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const deleteCommunicationGroup = (networkHeaders: any, id: string) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/groups/${id}`, {
    method: "DELETE",
    headers: networkHeaders,
  });

export const getSubscriptions = (networkHeaders: any) => () =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/subscriptions`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const postSubscription = (networkHeaders: any) => (id: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/subscriptions/${id}`, {
    method: "POST",
    headers: networkHeaders,
  });

export const deleteSubscription = (networkHeaders: any) => (id: string) =>
  fetch(`${AppSettings.NOTIFICATIONS_API_URL}/subscriptions/${id}`, {
    method: "DELETE",
    headers: networkHeaders,
  });
